import React, { useMemo } from "react"
import { Card, CardBody, CardTitle } from "reactstrap"
import { useSelector } from "react-redux"
import { useTranslation } from "react-i18next"

const EMPTY_CARDS = []

const APP_SETTINGS_MODES = new Set([
  "same_day_food",
  "immediate",
  "promise_window",
])

const DeliveryProfileSettings = () => {
  const { t } = useTranslation()
  const { deliveryProfilesScope } = useSelector(state => state.GlobalSettings)

  const cards = deliveryProfilesScope?.cards ?? EMPTY_CARDS

  const tenantEditableFields = useMemo(
    () =>
      cards
        .filter(card => APP_SETTINGS_MODES.has(card.mode))
        .map(card => ({
          ...card,
          fields: (card.fieldDefinitions || []).filter(field =>
            ["tenant", "both"].includes(field.editableBy)
          ),
        }))
        .filter(card => card.fields.length > 0),
    [cards]
  )

  return (
    <Card className="mb-4">
      <CardBody>
        <CardTitle tag="h5">{t("Delivery Profiles")}</CardTitle>
        <p className="text-muted mb-0">
          {tenantEditableFields.length
            ? t(
                "Brand delivery settings are managed under Delivery Setting. Use that page to configure prep time, cut-off, and scheduling rules per brand."
              )
            : t(
                "No brand delivery settings require configuration here. Scheduled, hybrid, and QSR brands are configured under Delivery Setting."
              )}
        </p>
      </CardBody>
    </Card>
  )
}

export default DeliveryProfileSettings
